export default {
  app: {
    privacy: {
      policy: 'política de privacidade',
      expansive: 'Ao usar o Expansive, você concorda com a {action} do Expansive',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Sessão expirada',
    sessionExpiredDescription:
      'Sua sessão expirou. Por favor, faça login novamente para continuar usando o aplicativo.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Escolher idioma',
      chooseLanguageDescription:
        'Escolha seu idioma preferido para o aplicativo. Isso mudará o idioma da interface e do conteúdo.',
    },
    userSelection: {
      cancel: 'Cancelar',
      createNewUser: 'O nome dele(a) não está listado',
      newUser: 'Novo usuário',
      selectAnExistingUser: 'Selecione um usuário existente',
      selectUserHint: 'Selecione um usuário existente ou crie um novo para continuar.',
      startTypingToSearch: 'Comece a digitar...',
    },
    verification: {
      codeVerification: {
        continue: 'Continuar',
        header: 'Digite o código de acesso ao local',
        invalidCode: 'Código inválido, tente novamente.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Continuar sem verificar localização',
        enterSiteAccessCode: 'Digite o código de acesso ao local',
        locationNotEnabledOrAvailable: 'Por que estou vendo isso?',
        notAvailable: {
          description: 'A localização GPS não é suportada neste dispositivo.',
          header: 'Localização não suportada',
        },
        notEnabled: {
          description:
            'Os serviços de localização não estão habilitados ou a permissão não foi concedida.',
          header: 'Localização não habilitada',
        },
        notVerified: {
          description: 'O GPS indica que você não está no local.',
          header: 'Localização não verificada',
        },
        tryAgain: 'Tentar novamente',
        unavailable: {
          description: 'Não foi possível verificar sua localização GPS.',
          header: 'Localização indisponível',
        },
        unknown: {
          description: 'Não foi possível determinar sua localização.',
          header: 'Localização desconhecida',
        },
        verified: {
          description: 'O GPS indica que você está no local.',
          header: 'Localização verificada',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Nenhum ativo encontrado',
        emptyDescription: 'Não há ativos associados a esta ordem de serviço.',
        warrantyParts: 'Garantia das peças expira',
        serialNumber: 'Número de série',
        none: '<nenhum>',
      },
      updates: {
        emptyTitle: 'Nenhuma atualização encontrada',
        emptyDescription: 'Não há atualizações para esta ordem de serviço.',
        unknownUser: 'Usuário desconhecido',
        none: 'Nenhum',
        addComment: {
          buttonLabel: 'Adicionar comentário',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Perigos',
          no: 'Não',
          yes: 'Sim',
        },
      },
    },
    attachmentsList: {
      attachments: 'Anexos',
      documents: 'Documentos',
      siteDocuments: 'Documentos do local',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Perigos',
        induction: 'Integração',
        safeToProceed: 'Seguro para prosseguir',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Data de vencimento',
        activeSessions: 'Sessões ativas',
        activeSessionsDescription:
          'Você já está registrado nas seguintes ordens de serviço. Você deve sair dessas ordens antes de entrar em uma nova.',
        resumeSession: 'Retomar',
        startTime: 'Iniciado em',
        unexpectedErrorTitle: 'Erro inesperado',
        unexpectedErrorMessage:
          'Ocorreu um erro inesperado ao tentar criar suas sessões. Por favor, tente novamente mais tarde.',
        engineerNotFound: 'Engenheiro não encontrado',
        engineerNotFoundDescription:
          'O engenheiro que você está tentando registrar não foi encontrado no sistema. Por favor, contate seu administrador.',
      },
      verification: {
        code: {
          description:
            'Para registrar-se, obtenha o código de 4 dígitos com o gerente do local ou contato designado.',
        },
        geo: {
          continue: 'Continuar',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Por favor, obtenha o código de acesso do gerente do site ou do contato designado para concluir sua visita.',
            checkOut: 'Sair',
            completeBeforeLeaving: 'Por favor, preencha o formulário a seguir antes de sair.',
            continue: 'Continuar',
            noResolutionSelected: 'Por favor, selecione uma resolução antes de continuar.',
            quoteRequired: {
              hint: 'Visita concluída, orçamento será enviado',
              label: 'Orçamento necessário',
            },
            returnVisitRequired: {
              hint: 'Voltaremos novamente para concluir',
              label: 'Retorno necessário',
            },
            serviceCompleted: {
              hint: 'Nenhuma ação adicional necessária',
              label: 'Serviço concluído',
            },
            uploadCheckout: 'Envie um arquivo, foto ou vídeo',
            visitNotes: 'Notas da visita',
            workOrderResolution: 'Resolução da ordem de serviço',
            enterNotes: 'Digite quaisquer observações aqui...',
            errors: {
              timedOut: 'Tempo esgotado, mais de 30 segundos. Por favor, tente novamente.',
              closingSession: 'Erro ao encerrar a sessão',
            },
          },
          success: {
            description:
              'Obrigado por visitar {site}. | {site} ainda possui 1 ordem de serviço aberta. | {site} ainda possui {count} ordens de serviço abertas.',
            endVisit: 'Encerrar visita',
            header: 'Você saiu com sucesso',
            viewWorkOrders: 'Entrar em outra ordem de serviço',
          },
          verification: {
            code: {
              description:
                'Para sair, obtenha o código de 4 dígitos com o gerente do local ou contato designado.',
              continue: 'Continuar',
            },
            geo: {
              checkOut: 'Sair',
              continue: 'Continuar',
            },
          },
        },
        detail: {
          assets: 'Ativos',
          call: 'Ligar',
          checkOut: 'Sair',
          closed: 'Fechado',
          details: 'Detalhes',
          dueBy: 'Data de vencimento',
          manageEngineers: 'Gerenciar engenheiros',
          notAvailable: 'Não disponível',
          pointOfContact: 'Pessoa de contato',
          siteAccessTimes: 'Horários de acesso ao local',
          siteAccessInstructions: 'Instruções de acesso',
          siteAddress: 'Endereço do local',
          siteNotes: 'Notas do local',
          siteTelephone: 'Telefone do local',
          siteLocation: 'Localização do site',
          updates: 'Atualizações',
          more: 'Mais',
          mismatchErrorTitle: 'Erro na ordem de serviço',
          mismatchErrorMessage:
            'A ordem de serviço que você está tentando acessar não corresponde à que você está registrado. Por favor, verifique sua ordem de serviço e tente novamente.',
          siteDocuments: 'Documentos do local',
          validFrom: 'Válido de',
          validUntil: 'Válido até',
          documentName: 'Nome do documento',
          documentType: 'Tipo de documento',
          attachments: 'Arquivos da ordem de serviço',
          download: 'Baixar',
          workDetails: 'Detalhes do serviço',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Adicionar engenheiro assistente',
            assistantEngineers: 'Engenheiros assistentes',
            description:
              'Por motivos de segurança, especifique o nome de cada engenheiro no local.',
            editMainEngineer: 'Editar engenheiro principal',
            errors: {
              creatingEngineer: 'Erro ao criar engenheiro',
              creatingSession: 'Erro ao criar sessão',
            },
            header: 'Engenheiros no local',
            mainEngineer: 'Engenheiro principal',
            newAssistantEngineer: 'Digite o nome completo',
            next: 'Próximo',
            removeEngineer: 'Remover engenheiro',
            selectExistingAssistantEngineer: 'Comece a digitar o nome',
          },
          index: {
            description:
              'Por motivos de segurança, especifique o nome de cada engenheiro no local.',
            errorCreatingEngineer: 'Erro ao criar engenheiro, tente novamente.',
            header: 'Engenheiros no local',
            hintMainEngineer: 'Digite o nome completo do engenheiro principal',
            newMainEngineer: 'Novo engenheiro principal',
            next: 'Próximo',
            selectExistingMainEngineer: 'Selecione um engenheiro principal existente',
            yes: 'Sim',
            no: 'Não',
            mainEngineerLabel: 'Você é o engenheiro principal?',
          },
        },
        index: {
          callUsOn: 'Ligue para {phoneNumber}',
          description: 'Não encontrou o que procura?',
          dueBy: 'Data de vencimento',
          header: 'Selecione a ordem de serviço',
          notAvailable: 'Não disponível',
          searchWorkOrders: 'Buscar ordens de serviço...',
        },
        manageEngineers: {
          manageEngineers: 'Gerenciar engenheiros',
          notWorking: 'Trabalhadores inativos',
          pause: 'Pausar',
          resume: 'Retomar',
          workingNow: 'Trabalhadores ativos',
          startTime: 'Hora de início',
          endTime: 'Hora de término',
          duration: 'Duração',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Feedback',
            feedbackDescription:
              'Por favor, forneça um feedback sobre a ordem de serviço para nos ajudar a melhorar nossos serviços.',
            feedbackLabel: 'Feedback',
            filesLabel: 'Anexos',
            submissionLabel: 'Enviar feedback',
          },
          hazards: {
            back: 'Voltar',
            hazards: 'Perigos',
            next: 'Próximo',
            no: 'Não',
            noTasksForHazard: 'Não há tarefas para este perigo.',
            yes: 'Sim',
          },
          induction: {
            continue: 'Continuar',
            induction: 'Integração',
          },
          index: {
            checkIn: 'Registrar entrada',
            description: 'Por favor, complete a avaliação de risco para o serviço selecionado.',
            fail: 'Falha ao processar as verificações iniciais da ordem de serviço.',
            haltMessage:
              'Riscos potenciais detectados. Pare o trabalho, revise as diretrizes de segurança e contate seu supervisor para mais instruções.',
            header: 'Verificações iniciais',
            endVisit: 'Encerrar visita',
            leaveFeedback: 'Deixar feedback',
          },
          safeToProceed: {
            continue: 'Continuar',
            safeToProceed: 'Seguro para prosseguir',
          },
        },
      },
    },
    index: {
      title: 'Bem-vindo',
      description: 'Escaneie o QR code no seu local para começar.',
    },
    login: {
      errorTitle: 'Erro inesperado',
      errorMessage: 'Ocorreu um erro inesperado. Por favor, tente escanear o QR code novamente.',
    },
    unauthenticated: {
      welcome: {
        title: 'Bem-vindo a {site}',
        description:
          'Antes de mostrar as ordens de serviço, precisamos verificar seus dados. Clique no botão abaixo para continuar.',
        next: 'Continuar',
      },
      index: {
        errorTitle: 'Erro inesperado',
        errorMessage: 'Ocorreu um erro inesperado. Por favor, tente escanear o QR code novamente.',
      },
      contractor: {
        title: 'Para quem você trabalha?',
        contractor: 'Contratada',
        contractorLabel: 'Comece a digitar o nome da empresa',
        contractorHint: 'Digite pelo menos 3 caracteres para ver resultados',
        defaultSelectPlaceholder: '--Selecione--',
        next: 'Próximo',
      },
      user: {
        title: 'Quem é você?',
        cancel: 'Cancelar',
        createNewUserLabel: 'Meu nome não está listado',
        existingUserLabel: 'Comece a digitar seu nome',
        existingUserHint: 'Digite pelo menos 3 caracteres para ver resultados',
        newUserLabel: 'Digite seu nome completo',
        next: 'Próximo',
        user: 'Usuário',
      },
      verification: {
        methods: {
          add: {
            add: 'Adicionar método de verificação',
            defaultSelectPlaceholder: '--Selecione--',
            emailLabel: 'E-mail',
            existingMethodWarning:
              'Você já possui uma solicitação pendente para este método aguardando aprovação do administrador. Adicionar um novo irá sobrescrever.',
            method: 'Método',
            methodLabel: 'Método',
            mobileCountryHint: 'Selecione o código do país',
            mobileCountryLabel: 'Código do país',
            mobileHint: 'Digite seu número de celular',
            mobileLabel: 'Celular',
            title: 'Adicionar método de verificação',
          },
          confirm: {
            confirm: 'Confirmar',
            description: 'Confirme seu método de verificação para continuar.',
            label: 'Digite seu código',
            resend: 'Reenviar',
            resendPrompt: 'Não recebeu o código?',
            title: 'Confirmar método de verificação',
          },
          confirmed: {
            description:
              'Você será notificado quando este método for aprovado pelo administrador e poderá usá-lo para verificar sua identidade.',
            forceApproval: 'Até ser aprovado, você não poderá acessar as ordens de serviço.',
            nonForceApproval:
              'Enquanto isso, você pode acessar as ordens de serviço com acesso reduzido.',
            nonForceApprovalButtonLabel: 'Continuar com acesso reduzido',
            title: 'Aguardando aprovação',
          },
          addNew: 'Adicionar novo método de verificação',
          description:
            'Precisamos verificar sua identidade para conceder acesso total à ordem de serviço.',
          email: 'E-mail',
          hint: 'Enviaremos um link para o método selecionado que dará acesso total à ordem de serviço. Para alterar métodos existentes, contate o administrador.',
          label: 'Selecione um método de verificação',
          next: 'Próximo',
          pendingHint: 'Aguardando aprovação do administrador',
          sms: 'SMS',
          title: 'Verificação',
        },
        optional: {
          hint: 'Verificar seus dados dará acesso total à ordem de serviço',
          label: 'Deseja verificar seus dados?',
          next: 'Próximo',
          no: 'Não',
          noHint:
            'Não quero verificar meus dados e continuarei com acesso reduzido à ordem de serviço',
          title: 'Verificação',
          yes: 'Sim',
          yesHint: 'Quero verificar meus dados e ter acesso total à ordem de serviço',
        },
        sent: {
          description:
            'Um link de login foi enviado para {identifier}. Clique no link para concluir o login.',
          title: 'Link de login enviado',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Ontem',
      today: 'Hoje',
      days: {
        monday: 'Segunda-feira',
        tuesday: 'Terça-feira',
        wednesday: 'Quarta-feira',
        thursday: 'Quinta-feira',
        friday: 'Sexta-feira',
        saturday: 'Sábado',
        sunday: 'Domingo',
      },
      months: {
        january: 'Janeiro',
        february: 'Fevereiro',
        march: 'Março',
        april: 'Abril',
        may: 'Maio',
        june: 'Junho',
        july: 'Julho',
        august: 'Agosto',
        september: 'Setembro',
        october: 'Outubro',
        november: 'Novembro',
        december: 'Dezembro',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Algo deu errado',
      message: 'Por favor, tente escanear o QR code novamente.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Usuário desconhecido',
      },
      none: 'Nenhum',
      types: {
        stateTransition: 'Status alterado',
        contractorAssigned: 'Contratada atribuída',
        engineerAssigned: 'Engenheiro atribuído',
        serviceAssigned: 'Serviço atribuído',
        priorityChanged: 'Prioridade alterada',
        actionableDateChanged: 'Data de ação alterada',
        dueDateChanged: 'Data de vencimento alterada',
        etaDateChanged: 'Data estimada de chegada alterada',
        spendLimitApproved: 'Limite de gastos aprovado',
        spendLimitCancelled: 'Solicitação de limite de gastos cancelada',
        spendLimitRejected: 'Limite de gastos rejeitado',
        spendLimitRequested: 'Limite de gastos solicitado',
        jobSheetUploaded: 'Ficha de trabalho enviada',
        slaAlertSent: 'Alerta de SLA estourado',
        issuedWorkPermit: 'Permissão de trabalho emitida',
        requestForServiceSent: 'Solicitação de serviço enviada',
        comment: 'Comentário adicionado',
        unknown: 'Evento desconhecido',
      },
      labels: {
        actionableDate: 'Data de ação',
        comment: 'Comentário',
        file: 'Arquivo',
        contractor: 'Contratada',
        dueDate: 'Data de vencimento',
        etaDate: 'Data estimada de chegada',
        engineer: 'Engenheiro',
        priority: 'Prioridade',
        requestForService: 'Solicitação de serviço',
        service: 'Serviço',
        spendLimit: 'Limite de gastos',
        status: 'Status',
        workPermit: 'Permissão de trabalho',
      },
    },
  },
}
